import React from 'react'
import styles from './GameCard.module.css'

const GameCard = ({ game, onClick }) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onClick(game)
    }
  }

  return (
    <div className={styles.card} onClick={() => onClick(game)} onKeyDown={handleKeyDown} role="button" tabIndex={0}>
      <img className={styles.thumbnail} src={game.thumbnail} alt={game.title} loading="lazy" />
      <div className={styles.overlay}>
        <span className={styles.overlayTitle}>{game.title}</span>
      </div>
    </div>
  )
}

export default GameCard
